import { AcsAuthModel } from './acs-auth.model';
import { BaseModel } from './base.model';

export class AdAuthModel extends BaseModel {
  static CONNECTION_STATUS_CONNECTED = 'connected';
  static CONNECTION_STATUS_DISCONNECTED = 'disconnected';

  static NOTIFICATION_CHANNEL_EMAIL = 'email';
  static NOTIFICATION_CHANNEL_TEAMS = 'teams';
  static NOTIFICATION_CHANNEL_EMAIL_AND_TEAMS = 'email,teams';

  id: number;
  instanceId: number;
  clientId: string;
  clientSecret: string;
  tenenatId: string;
  objectId: string;
  redirectUrl: string;
  notificationChannel: string;
  scopes: any;
  connectionStatus: string;
  hasGroups: 0 | 1;
  isActive: 0 | 1;

  acsAuth?: AcsAuthModel;

  get childModels(): {} {
    return {
      acsAuth: AcsAuthModel,
    };
  }

  get unsafeApiAttributes() {
    return [];
  }

   toApi(model?: this): {} {
    return {
      ...super.toApi(model),
    };
  }

  get isConnectedToAd(): boolean {
    return this.connectionStatus === AdAuthModel.CONNECTION_STATUS_CONNECTED;
  }

  get isConnectedToAcs(): boolean {
    return this.acsAuth?.connectionStatus === AdAuthModel.CONNECTION_STATUS_CONNECTED;
  }

  get isNotConnectedToAd(): boolean {
    return !this.connectionStatus || this.connectionStatus === AdAuthModel.CONNECTION_STATUS_DISCONNECTED;
  }
}
